import React from 'react';
import { Plus, Layout } from 'lucide-react';

interface EmptyDashboardProps {
  onAddWidget: () => void;
}

const EmptyDashboard: React.FC<EmptyDashboardProps> = ({ onAddWidget }) => {
  return (
    <div className="flex flex-col items-center justify-center h-96 bg-white dark:bg-gray-800 rounded-xl border-2 border-dashed border-gray-300 dark:border-gray-700">
      <div className="p-4 bg-gray-100 rounded-full mb-4">
        <Layout className="h-12 w-12 text-gray-400" />
      </div>
      <h3 className="text-lg font-semibold text-gray-900 mb-2">Seu dashboard está vazio</h3>
      <p className="text-sm text-gray-500 mb-6 text-center max-w-md">
        Comece adicionando widgets para personalizar seu painel de controle e visualizar as informações mais importantes.
      </p>
      <button
        onClick={onAddWidget}
        className="flex items-center gap-2 px-6 py-3 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
      >
        <Plus className="h-5 w-5" />
        Adicionar Primeiro Widget
      </button>
    </div>
  );
};

export default EmptyDashboard;





